import type { NnnRegistrationRow } from '@/services';

export function sortRowsByOrder(rows: NnnRegistrationRow[]): NnnRegistrationRow[] {
  return [...rows].sort((a, b) => a.rowOrder - b.rowOrder);
}
